// extracted by mini-css-extract-plugin
module.exports = {"container":"musicPageStyle-module--container--3p5eg","topbar":"musicPageStyle-module--topbar--7dcSs","bottombar":"musicPageStyle-module--bottombar--1Ts07"};